import React from 'react'
import PropTypes from 'prop-types'
import TeamMemberCard from '../Shared/TeamMemberCard/TeamMemberCard'
import styles from './DedicatedTeam.module.scss'

const renderfirstTeamMember = (firstTeamMember, isMobile) => (
  <div className={styles.firstColumn}>
    <TeamMemberCard
      isMobile={isMobile}
      name={firstTeamMember.name}
      primaryText={firstTeamMember.name}
      secondaryText={firstTeamMember.title}
      phone={firstTeamMember.mobilePhone}
      email={firstTeamMember.email} />
  </div>
)

const renderNextTeamMembers = (remainingTeamMembers,isMobile) => {
  let columnStyles = styles.column

  if (remainingTeamMembers.length === 1) {
    columnStyles = styles.singleColumn
  }


  return remainingTeamMembers.map((member, index) => (
    <div key={member.name} className={columnStyles}>
      <TeamMemberCard
        isMobile={isMobile}
        avatarSize="medium"
        name={member.name}
        primaryText={member.firstName}
        secondaryText={member.title}
        infoPosition="bottom" />
    </div>
  ))
}


const DedicatedTeam = (props) => {
  const { firstTeamMember, nextTeamMembers, isMobile } = props

  return (
    <div className={styles.container}>
      <div className={styles.title}>
        Your dedicated
        Ellevest team
      </div>
      <div className={styles.row}>
        {renderfirstTeamMember(firstTeamMember, isMobile)}
      </div>
      <div className={styles.divider} />
      <div className={styles.row}>
        {renderNextTeamMembers(nextTeamMembers, isMobile)}
      </div>
    </div>
  )
}

DedicatedTeam.defaultProps = {
  nextTeamMembers: [],
  firstTeamMember: {},
  isMobile: false
}

DedicatedTeam.propTypes = {
  nextTeamMembers: PropTypes.array,
  firstTeamMember: PropTypes.object,
  isMobile: PropTypes.bool,
}

export default DedicatedTeam



// WEBPACK FOOTER //
// ./src/components/Client/DedicatedTeam/DedicatedTeam.jsx